/**
 * Gece senkronu ön-kontrolünün METİN üretimi (Sorgu Snapshot Faz 3, DEV-2967).
 *
 * Saf: store, DOM, `Notification` ve `app` bilmez. Durumu toplayan ve bildirimi
 * gösteren taraf uygulamadır (`icrapro-app/src/plugins/senkronOnKontrol.ts`);
 * bu ayrım `BaglantiKurtarma`nın kanca deseniyle aynı gerekçeye dayanır —
 * plugin'i iki farklı uygulama kullanıyor ve ikisi bildirimi farklı gösteriyor.
 */

export interface OnKontrolDurumu {
    /** `GET /v1/senkron-plan` okunabildi mi. */
    planlarOkunabildi: boolean;
    /** Okunabildiyse kaç plan aktif. */
    aktifPlanSayisi: number;
    /** `probe()` ile doğrulanmış canlı UYAP oturumu. */
    uyapOturumuCanli: boolean;
    /** İmza uygulaması (botu koşturan taraf) bağlı mı. */
    imzaBagli: boolean;
    /** Bot "oto" modunda mı — değilse görevler kuyruğa girer ama koşmaz. */
    botOtoda: boolean;
    /** Devre kesici açıksa bot ban riskine karşı sert durdurulmuş demektir. */
    devreKesiciAcik: boolean;
}

export interface OnKontrolMesaji {
    baslik: string;
    metin: string;
    /** true ise uyarı sesi de çalınır; "hazır" bildiriminde çalınmaz. */
    kritikMi: boolean;
}

/**
 * Kontrol sonucundan bildirim metnini kurar.
 *
 * `null` döndürmek "bildirim GÖSTERME" demektir ve tek bir durumda olur: plan
 * listesi okunabildi ve HİÇ aktif plan yok. Senkronu hiç kurmamış kullanıcıyı
 * her gece 22:45'te dürtmenin bir anlamı olmazdı.
 */
export function onKontrolMesajiOlustur(durum: OnKontrolDurumu): OnKontrolMesaji | null {
    const eksikler: string[] = [];

    if (!durum.planlarOkunabildi) {
        eksikler.push("Senkron planları sunucudan okunamadı; bu gece koşacak plan bilinmiyor.");
    } else if (durum.aktifPlanSayisi < 1) {
        return null;
    }

    // Devre kesici en başta: açıkken diğer eksikler giderilse bile bot koşmaz.
    if (durum.devreKesiciAcik) {
        eksikler.push("UYAP bağlantısında tekrarlayan hata nedeniyle işlemler durduruldu (devre kesici açık).");
    }
    if (!durum.imzaBagli) {
        eksikler.push("İmza uygulaması bağlı değil; görevleri koşacak taraf ayakta değil.");
    }
    if (!durum.uyapOturumuCanli) {
        eksikler.push("UYAP oturumu düşmüş; e-imzayla yeniden bağlanın.");
    }
    if (!durum.botOtoda) {
        eksikler.push("Otomatik mod kapalı; Görevler sayfasından \"Görevleri Başlat\" deyin.");
    }

    if (eksikler.length > 0) {
        return {
            baslik: "Gece senkronu çalışmayabilir",
            metin: eksikler.map((satir) => "• " + satir).join("\n"),
            kritikMi: true
        };
    }

    const plan = durum.aktifPlanSayisi === 1 ? "1 plan" : `${durum.aktifPlanSayisi} plan`;

    return {
        baslik: "Gece senkronu hazır",
        metin: `UYAP ve imza bağlı, otomatik mod açık — bu gece ${plan} koşacak.`,
        kritikMi: false
    };
}
